import { render, staticRenderFns } from "./FormulateS3FileUploader.vue?vue&type=template&id=06dd12ef"
import script from "./FormulateS3FileUploader.vue?vue&type=script&lang=js"
export * from "./FormulateS3FileUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports